module.exports = __webpack_public_path__ + "img/For_Wes.4ceb460a.jpg";